<template>
    <apexchart :type="typeChart" :height="heightChart" :options="options" :series="series.series"></apexchart>
</template>

<script>
export default {
    name: "ringChart",
    props: {
        typeChart: {
            type: String,
            default: "donut"
        },
        heightChart: {
            type: String,
            default: '100%'
        },
        series: {
            type: Object
        },        
        labels: {
            type: Array
        },
        colors: {
            type: Array
        },
        total: {
            type: String,
            default: ""
        },
        showLabel: {
            type: Boolean,
            default: true
        },
        click: Function
    },
    data: () => ({
    }),
    computed: {
        options() {
            return {
                labels: this.labels,
                colors: this.colors,
                chart: {
                    type: this.typeChart,
                    height: this.heightChart,
                    toolbar: {
                        show: false,
                    },
                    events: {
                        //click: this.click,
                        dataPointSelection: this.click
                    }
                },
                legend: {
                    position: 'bottom',
                },
                responsive: [{
                    breakpoint: 1080,
                    options: {
                        legend: {
                            position: 'bottom',
                            offsetY: 0,
                        }
                    }
                }],
                stroke: {
                    show: false,
                },
                dataLabels: {
                    enabled: true,
                    dropShadow: {
                        enabled: false,
                    },
                    formatter: (val, opts) => {
                        return this.series.values[opts.seriesIndex]
                    },
                },
                plotOptions: {
                    pie: {
                        donut: {
                            size: '45%',
                            labels: {
                                show: this.showLabel,
                                name: {
                                    show: false,
                                },
                                value: {
                                    show: true,
                                    fontSize: '20px',
                                    fontWeight: 700,
                                    color: '#494f59',
                                    formatter: (val) => {
                                        return val
                                    },
                                    offsetY: 5,
                                },
                                total: {
                                    show: true,
                                    showAlways: true,
                                    formatter: () => {
                                        return this.total;
                                    }
                                }
                            }
                        }
                    },
                    radialBar: {
                        //offsetY: -20,
                        hollow: {
                            margin: 5,
                            size: '100%',
                            background: 'transparent',
                            image: undefined,
                        },
                        track: {
                            strokeWidth: '100%',
                            margin: -100 // задвигает кольцо ближе к краю контейнера
                        },
                        dataLabels: {
                            show: true,
                            name: {
                                show: false,
                            },
                            value: {
                                formatter: (val) => {
                                    return val.config.series[0] + '%';
                                }, 
                                fontSize: '20px',
                                fontWeight: 700,
                                color: '#494f59',
                                show: true,
                                offsetY: 5,
                            },
                            total: {
                                formatter: (val) => {
                                    return val.config.series[0] + '%';
                                }, 
                                show: true,
                                showAlways: true,
                            }
                        }
                    }
                },
                tooltip: {
                    enabled: true,
                    // x: {
                    //     show: false,
                    // },
                    custom: ({/*series,*/ seriesIndex, w}) => {
                        //console.log(seriesIndex, w);
                        return `
                            <div class="apexcharts-tooltip-series-group apexcharts-active" style="order: 1; display: flex; background-color: ${w.config.colors[seriesIndex]};">
                                <div class="apexcharts-tooltip-text" style="font-size:12px;color:#fff"">
                                    <div class="apexcharts-tooltip-y-group">
                                        <span class="apexcharts-tooltip-text-y-label">${w.config.labels[seriesIndex]}: </span>
                                        <span class="apexcharts-tooltip-text-y-value">${this.series.values[seriesIndex]}</span>
                                    </div>
                                </div>
                            </div>`;
                    }
                },
            }
        }
    },
}
</script>